import { CommodityInterface } from "../../interface";

export const dayWiseHeaderRowConfig = [
  {
    id: "checkbox",
    colSpan: 1,
    label: " ",
    sx: {
      borderRight: "none",
      left: 0,
      zIndex: 14
    }
  },
  {
    id: "produceCommodities",
    colSpan: 2,
    label: " ",
    subComponents: [{ id: "produceCommodities", text: "commodities" }],
    sx: {
      left: 83,
      zIndex: 14,
      "& div": {
        width: "314px"
      }
    }
  },
  {
    id: "casesAndMasterDisplay",
    label: " ",
    colSpan: 2,
    sx: { zIndex: 14, left: 414 }
  },
  { id: "sunday", day: 0, colSpan: 6 },
  { id: "monday", day: 1, colSpan: 6 },
  { id: "tuesday", day: 2, colSpan: 6 },
  { id: "wednesday", day: 3, colSpan: 6 },
  { id: "thursday", day: 4, colSpan: 6 },
  { id: "friday", day: 5, colSpan: 6 },
  { id: "saturday", day: 6, colSpan: 6 },
  { id: "totalCasesSold", label: " ", colSpan: 2 }
];

export const setCommoditiesForTable = (commodities: {
  [key: string]: CommodityInterface;
}) => {
  const commoditiesForTable = [];

  for (const [itemId, commodity] of Object.entries(commodities)) {
    const dailyProductData = {} as any;
    for (const [day, dailyProduct] of Object.entries(
      commodity.dailyProductData || {}
    )) {
      dailyProductData[`${day}-prodReq`] = dailyProduct.productRequired;
      dailyProductData[`${day}-inventoryBackStore`] =
        dailyProduct.inventoryBackStore;
      dailyProductData[`${day}-inventoryCounter`] =
        dailyProduct.inventoryCounter;
      dailyProductData[`${day}-order`] = dailyProduct.order;
      dailyProductData[`${day}-received`] = dailyProduct.received;
      dailyProductData[`${day}-prodAvail`] = dailyProduct.productAvailable;
      dailyProductData[`${day}-over/short`] = dailyProduct.overShort;
      dailyProductData[`${day}-casesSold`] = dailyProduct.casesSold;
    }
    const commodityData = {
      itemId,
      ...commodity,
      ...dailyProductData
    };
    commoditiesForTable.push(commodityData);
  }

  return commoditiesForTable;
};

export const getNextIndex = (index: number, currentId: string) => {
  const dayIndex = currentId.split("-")[0];
  // tab navigation for item details
  if (currentId.includes("forecastSales")) {
    return `${index}-orderFactor`;
  } else if (currentId.includes("orderFactor")) {
    return `${index}-actualSales`;
  } else if (currentId.includes("actualSales")) {
    return `${index + 1}-forecastSales`;
  } else if (currentId.includes("pack")) {
    return `${index}-size`;
  } else if (currentId.includes("size")) {
    return `${index}-casesPerThousand`;
  } else if (currentId.includes("casesPerThousand")) {
    return `${index}-masterDisplay`;
  } else if (currentId.includes("masterDisplay")) {
    return `${index + 1}-pack`;
  } else if (currentId.includes("inventoryBackStore")) {
    return `${index}-${dayIndex}-inventoryCounter`;
  } else if (currentId.includes("inventoryCounter")) {
    return `${index}-${dayIndex}-received`;
  } else if (currentId.includes("received")) {
    return `${index + 1}-${dayIndex}-inventoryBackStore`;
  }
};

export const getNextColumn = (currentId: string, currentIndex: number) => {
  if (currentId.includes("masterDisplay")) {
    return "0-0-inventoryBackStore";
  } else if (currentId.includes("received")) {
    const dayIndex = currentId.split("-")[0];
    return `0-${+dayIndex + 1}-inventoryBackStore`;
  } else if (currentId.includes("orderFactor")) {
    return `${+currentIndex + 1}-forecastSales`;
  }
};
